import { AnyAction } from "redux";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { action } from "typesafe-actions";

import api from "../../../api";
import { AdvertiserType } from "../../../types/advertiserTypes";
import { AgencyType } from "../../../types/agencyTypes";
import { PlayBook } from "../../../types/playBookTypes";
import { SET_ADVERTISERS, SET_AGENCY, SET_PLAYBOOKS, SetUpdatedAgencyAction } from "./types";
import { handleApiResponse } from "../../../utils/handleApiResponse";
import { setApiError } from "../apiError/actions";

export const setAgency = (agency: AgencyType): SetUpdatedAgencyAction => action(SET_AGENCY, agency);

export const setAdvertisers = (payload: AdvertiserType[]) => action(SET_ADVERTISERS, payload);

export const setPlayBooks = (payload: PlayBook[]) => action(SET_PLAYBOOKS, payload);

export const createAgency =
  (agency: Partial<AgencyType>): ThunkAction<Promise<void>, {}, {}, AnyAction> =>
  async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
    const selectedAgency = await api.createBrandgenAgency(agency);

    dispatch(handleApiResponse(selectedAgency, setAgency, setApiError));
  };

export const setAgencyAdvertisers = (agencyId: string): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
    const advertisersByAgency = await api.fetchAdvertisersByAgency(agencyId);
    dispatch(handleApiResponse(advertisersByAgency, setAdvertisers, setApiError));
  };
};

export const setBrandgenPlayBooks = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
    const playBooks = await api.getPlayBooks();
    dispatch(handleApiResponse(playBooks, setPlayBooks, setApiError));
  };
};
